export function getRandomIdKey() {
  return Math.floor(1000000000 + Math.random() * 9000000000)
}



// WEBPACK FOOTER //
// ./src/utilities/math.utilities.js